export default "__VITE_ASSET__DJR$5G5F__"